export default "__VITE_ASSET__Iysa7qkZ__"